import React from "react";
import Avatar from "@/components/Avatar";

/** Compact members list rendered in the right drawer for a channel. */
export default function MembersList({ members }) {
  return (
    <div className="p-3 space-y-2">
      {members.map((m) => (
        <div key={m.user_id} className="flex items-center gap-3">
          <Avatar user={m.user} size="md"/>
          <div>
            <div className="text-sm">{m.user?.name}</div>
            <div className="text-xs text-zinc-500">{m.role} · {m.department}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
